import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import './AuthPages.css';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => { if (!token) setError('Invalid reset link. Please request a new one.'); }, [token]);

  const strength = newPassword.length >= 12 ? 'strong' : newPassword.length >= 8 ? 'ok' : 'weak';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword.length < 8) { setError('Password must be at least 8 characters'); return; }
    if (newPassword !== confirm) { setError('Passwords do not match'); return; }
    setLoading(true); setError('');
    try {
      await api.post('/auth/reset-password', { token, new_password: newPassword });
      setDone(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) { setError(err.response?.data?.error || 'Failed to reset password. The link may have expired.'); }
    finally { setLoading(false); }
  };

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <div className="auth-logo">BrokerConnect</div>
        {done ? (
          <div className="auth-sent">
            <div className="auth-sent-icon">Done</div>
            <h2 className="auth-title">Password reset</h2>
            <p className="auth-desc">Your password has been updated. Redirecting you to login...</p>
            <Link to="/login" className="auth-link">Go to login</Link>
          </div>
        ) : (
          <>
            <h2 className="auth-title">Set a new password</h2>
            <p className="auth-desc">Choose a strong password for your BrokerConnect account.</p>
            {error && <div className="auth-error">{error}</div>}
            <form onSubmit={handleSubmit} className="auth-form">
              <div className="auth-field">
                <label className="auth-label" htmlFor="newPassword">New password</label>
                <div className="auth-pw-row">
                  <input id="newPassword" type={showPw ? 'text' : 'password'} className="auth-input" value={newPassword} onChange={e => setNewPassword(e.target.value)} placeholder="Minimum 8 characters" required autoFocus />
                  <button type="button" className="auth-pw-toggle" onClick={() => setShowPw(s => !s)}>{showPw ? 'Hide' : 'Show'}</button>
                </div>
                {newPassword.length > 0 && <div className={"auth-strength auth-strength--" + strength}>{strength === 'strong' ? 'Strong password' : strength === 'ok' ? 'Acceptable' : 'Too short'}</div>}
              </div>
              <div className="auth-field">
                <label className="auth-label" htmlFor="confirm">Confirm password</label>
                <input id="confirm" type={showPw ? 'text' : 'password'} className="auth-input" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Repeat your new password" required />
                {confirm.length > 0 && newPassword !== confirm && <div className="auth-strength auth-strength--weak">Passwords do not match</div>}
              </div>
              <button type="submit" className="auth-btn" disabled={loading || !token}>{loading ? 'Updating...' : 'Reset password'}</button>
            </form>
            <div className="auth-footer">
              <Link to="/login" className="auth-link">Back to login</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
